import API from '@/lib/API.js'
import comun from './comun.js'
const localidades = {
  namespaced: true,
  state: {
    Lista: [],
    Filtradas: [],
    Seleccionado: undefined
  },
  mutations: {
    init(state) {
      state.Filtradas = [];
      state.Seleccionado = undefined
    },
    set(state, payload) {
      state.Lista = payload;
    },
    setCodigoPostal(state, payload) {
      state.codigo_postal = payload;
    },
  },
  actions: {
    async set({
      commit,
      getters
    }) {
      let entidades = getters.getLocalidades();
      if (entidades.length === 0) {
        commit("comun/cargando")
        let data = JSON.parse(localStorage.getItem('locs'));
        if (!data) {
          data = await API.Localidades.traerTodos();
          window.localStorage.setItem('locs', JSON.stringify(data));
        }
        commit("set", data)
        commit("comun/fincarga")
      }
    },
    async setCodigoPostal({
      commit
    }, codigo_postal) {
      commit("setCodigoPostal", parseInt(codigo_postal))
    },
  },
  getters: {
    getLocalidades: state => () => {
      return state.Lista;
    },
    localidadesFiltradas: (state) => () => {
      if (state.codigo_postal) {
        const filt = state.Lista.filter((x) => x.codigo_postal == state.codigo_postal);
        return filt;
      }
      return [];
    },
  },
  modules: {
    comun
  }

}
export default localidades;